var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled, { css } from 'styled-components';
export var ImageAlignContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
  var align = _a.align;
  return align !== undefined ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          text-align: ", ";\n        "], ["\n          text-align: ", ";\n        "])), align) : '';
});
export var StyledImage = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  ", ";\n"], ["\n  max-width: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  ", ";\n"])), function (_a) {
  var isResponsive = _a.isResponsive;
  return isResponsive ? '100%' : 'none';
}, function (_a) {
  var width = _a.width;
  return width ? "".concat(Number(width), "px") : '100%';
}, function (_a) {
  var height = _a.height;
  return height ? "".concat(Number(height), "px") : 'auto';
}, function (_a) {
  var rounded = _a.rounded;
  return rounded ? '50%' : '0';
}, function (_a) {
  var align = _a.align;
  return align !== undefined ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          width: auto;\n        "], ["\n          width: auto;\n        "]))) : '';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;